/* Golfstore — Omschrijving-tabs
   Desktop: tabwissel met muis én pijltjestoetsen (roving tabindex, zoals de
   WAI-ARIA tabs-pattern voorschrijft). Mobiel: accordeon-toggle per paneel. */
(function () {
  'use strict';

  function tabsOf(root) {
    return Array.prototype.slice.call(root.querySelectorAll('[data-dtab]'));
  }

  function activate(root, idx, moveFocus) {
    tabsOf(root).forEach(function (t) {
      var on = t.getAttribute('data-dtab') === idx;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', String(on));
      t.setAttribute('tabindex', on ? '0' : '-1');
      if (on && moveFocus) t.focus();
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-dpanel]'), function (p) {
      var on = p.getAttribute('data-dpanel') === idx;
      p.classList.toggle('is-active', on);
      p.classList.toggle('is-open', on);
      var head = p.querySelector('[data-dhead]');
      if (head) head.setAttribute('aria-expanded', String(on));
    });
  }

  function init(root) {
    if (root.__gsdt) return;
    root.__gsdt = true;

    root.addEventListener('click', function (e) {
      var tab = e.target.closest('[data-dtab]');
      if (tab) {
        activate(root, tab.getAttribute('data-dtab'), false);
        return;
      }
      var head = e.target.closest('[data-dhead]');
      if (head) {
        var panel = head.parentNode;
        var open = panel.classList.toggle('is-open');
        head.setAttribute('aria-expanded', String(open));
      }
    });

    /* Pijltjes, Home en End binnen de tabrij. */
    var bar = root.querySelector('[role="tablist"]');
    if (!bar) return;
    bar.addEventListener('keydown', function (e) {
      var keys = ['ArrowRight', 'ArrowLeft', 'Home', 'End'];
      if (keys.indexOf(e.key) < 0) return;
      var tabs = tabsOf(root);
      if (!tabs.length) return;
      var current = tabs.findIndex(function (t) { return t.getAttribute('aria-selected') === 'true'; });
      if (current < 0) current = 0;
      var next = current;
      if (e.key === 'ArrowRight') next = (current + 1) % tabs.length;
      else if (e.key === 'ArrowLeft') next = (current - 1 + tabs.length) % tabs.length;
      else if (e.key === 'Home') next = 0;
      else if (e.key === 'End') next = tabs.length - 1;
      e.preventDefault();
      activate(root, tabs[next].getAttribute('data-dtab'), true);
    });
  }

  function initAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-dtabs]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();